import React from 'react';
import PropTypes from 'prop-types';

const VideoStatus = ({ isLoading, errorMessage }) => {
	if (errorMessage) {
		return (
			<div className="video-status video-status-error" role="alert">
				{errorMessage}
			</div>
		);
	}

	if (isLoading) {
		return (
			<div className="video-status video-status-loading" role="status">
				<span className="video-status-spinner" aria-hidden="true" />
			</div>
		);
	}

	return null;
};

VideoStatus.propTypes = {
	isLoading: PropTypes.bool,
	errorMessage: PropTypes.string
};

VideoStatus.defaultProps = {
	isLoading: false,
	errorMessage: ''
};

export default VideoStatus;
